import React, { useEffect, useMemo, useRef, useState } from 'react'
import { ProjectCard } from '../../components/ProjectCard'
import { JSONLD } from '../../components/JSONLD'

const PAGE_SIZE = 6

const ProjectsSection = () => {
  const [visible, setVisible] = useState(PAGE_SIZE)
  const [projectsData, setProjectsData] = useState([])
  const [loading, setLoading] = useState(true)
  const sentinelRef = useRef(null)

  // Fetch projects data
  useEffect(() => {
    fetch('/data/projects.json')
      .then(response => response.json())
      .then(data => {
        setProjectsData(data)
        setLoading(false)
      })
      .catch(error => {
        console.error('Error loading projects:', error)
        setLoading(false)
      })
  }, [])

  const allProjects = projectsData
  const results = useMemo(() => allProjects, [allProjects])
  const visibleProjects = results.slice(0, visible)
  const canLoadMore = visible < results.length

  // Infinite scroll
  useEffect(() => {
    if (!canLoadMore) return
    const el = sentinelRef.current
    if (!el) return
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(v => Math.min(v + PAGE_SIZE, results.length))
        }
      })
    }, { rootMargin: '300px' })
    io.observe(el)
    return () => io.disconnect()
  }, [canLoadMore, results.length])

  if (loading) {
    return <div className="text-center text-sm text-gray-500 py-12">Loading projects...</div>
  }

  return (
    <div>
      {visibleProjects.length === 0 ? (
        <div className="text-center text-sm text-gray-500 py-12">No projects match your filters.</div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {visibleProjects.map(p => (
            <div id={p.id} key={p.id}>
              <ProjectCard project={p} />
            </div>
          ))}
        </div>
      )}

      {canLoadMore && (
        <div ref={sentinelRef} aria-hidden="true" className="h-12 flex items-center justify-center text-xs text-gray-500">
          Loading more…
        </div>
      )}

      <JSONLD projects={allProjects} />
    </div>
  )
}

export default ProjectsSection
